import dayjs from 'dayjs'
import AppHeader from '../AppHeader'
import EsMyCardSubMenu from '../EsMyCardSubMenu'
let utils = require('../../utils')
import $ from 'jquery'
global.jQuery = $
window.jQuery = $

export default {
  name: 'es-mycard-list',
  created () {
    if (window.sessionStorage.getItem('mycard_list_scroll_top')) {
      const data = JSON.parse(window.sessionStorage.getItem('mycard_list_scroll_top'))
      this.selectedTab = data.selectedTab
      this.selectedShop = data.selectedShop
      this.sortStart.year = data.sortStart.year
      this.sortStart.month = data.sortStart.month
      this.sortStart.day = data.sortStart.day
      this.sortEnd.year = data.sortEnd.year
      this.sortEnd.month = data.sortEnd.month
      this.sortEnd.day = data.sortEnd.day
      this.currentPage = data.currentPage
      this.shopId = data.shopId
      this.userTypeId = data.userTypeId
      this.userName = data.userName

      this.setSelectedDate('backPageLoad')
      this.search('backPageLoad')
      this.accordion = false
    } else {
      this.search('firstLoad')
    }
    this.getShopName()
    this.getUserTypes()
    this.getShops()

    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, 'addLoad', 'button.next-page-search-btn')
  },
  components: {
    AppHeader,
    EsMyCardSubMenu
  },
  filters: {
    formatDate (date) {
      return dayjs(date).format('YYYY/MM/DD HH:mm')
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  updated () {
    if (window.sessionStorage.getItem('mycard_list_scroll_top') && this.searchEnd === true && this.displayShopName) {
      const data = JSON.parse(window.sessionStorage.getItem('mycard_list_scroll_top'))
      if (data['path'] === this.$router.history.current.path) {
        $(window).scrollTop(data['scrollTop'])
        // 自動スクロール後の手動スクロールイベントの発生でセッションからスクロール情報を削除する。そのためのフラグ。
        this.isScrollDoneFlag = true
      }
    }
  },
  data: () => ({
    selectedTab: 'new', // new or like
    selectedShop: 'my', // my or all,
    accordion: false,
    sortStart: {
      year: '',
      month: '',
      day: ''
    },
    sortStartsToString: '',
    sortEnd: {
      year: '',
      month: '',
      day: ''
    },
    sortEndsToString: '',
    cardList: [],
    showHamburgerList: [],
    deleteTarget: null,
    deleteTargetIndex: null,
    showDeleteCardCompleteModal: false,
    searchEnd: false,
    nextExist: false,
    currentPage: 0,
    displayShopName: '',
    dayCount: '',
    endDayCount: '',
    isScrollDoneFlag: false,
    displayToday: '',
    displayLastMounthDate: '',
    isReportProblemModal: false,
    reportTargetIndex: null,
    isProblemReported: false,
    isLikePushing: false,
    userTypeId: null,
    shopId: null,
    userName: '',
    shopNameToString: '',
    userTypeToString: '',
    userNameToString: ''
  }),
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    const $win = $(window)
    $win.on('load scroll', function () {
      $('.es-mycard-list').css('margin-top', 0)
    })
    if (to.name === 'EsMyCardDetail' || to.name === 'EsMyCardLikeList') {
      const savedata = {
        'path': this.$router.history.current.path,
        'scrollTop': $(window).scrollTop(),
        'selectedTab': this.selectedTab,
        'selectedShop': this.selectedShop,
        'sortStart': this.sortStart,
        'sortEnd': this.sortEnd,
        'currentPage': this.currentPage,
        'shopId': this.shopId,
        'userTypeId': this.userTypeId,
        'userName': this.userName
      }
      window.sessionStorage.setItem('mycard_list_scroll_top', JSON.stringify(savedata))
    } else {
      window.sessionStorage.removeItem('mycard_list_scroll_top')
    }
    next()
  },
  computed: {
    isSettedSortStarts () {
      return this.sortStart.year && this.sortStart.month && this.sortStart.day
    },
    isSettedSortEnds () {
      return this.sortEnd.year && this.sortEnd.month && this.sortEnd.day
    },
    getBackgroundImageByImageName () {
      return imageName => {
        return require(`../../../static/mycard/background/${imageName}.png`)
      }
    },
    getCharacter1ImageByImageName () {
      return (pathName, imageName) => {
        return require(`../../../static/mycard/character1/${pathName}/${imageName}.png`)
      }
    },
    getUserImage () {
      return imagePath => {
        if (imagePath) {
          return `${imagePath}?token=${localStorage.access_token}&timestamp=${this.timeStamp}`
        }
        return require('../images/icon_submenu_face.png')
      }
    },
    getFrontImageByPath () {
      return imagePath => {
        return `${imagePath}` + '?token=' + localStorage.access_token + '&timestamp=' + this.timeStamp
      }
    },
    getLikeImageByState () {
      return state => {
        if (state) {
          return require('../images/icon_heart_pink.png')
        }
        return require('../images/icon_heart_blank.png')
      }
    },
    getFavoriteImageByState () {
      return state => {
        if (state) {
          return require('../images/icon_star_yellow.png')
        }
        return require('../images/icon_star_blank.png')
      }
    },
    selectYears () {
      let ret = []
      let startYear = 2019
      let today = new Date()
      let year = today.getFullYear()
      for (var i = startYear; i <= year; i++) {
        ret.push(i)
      }
      return ret
    },
    timeStamp () {
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    },
    userTypes () {
      let results = [{ id: null, type: 'user-types', attributes: { 'user-type-name': '役職を選択' }}]
      return results.concat(this.$store.getters.usertypesAll.filter(userType => {
        // 表示しない役職を取り除く
        if (![210, 230, 250, 345, 346, 361, 362, 715, 725, 788, 795, 797].includes(Number(userType.id))) {
          return userType
        }
      }))
    },
    userTypeName () {
      let res = this.$store.getters.usertypesAll.find(item => {
        return item.id === this.userTypeId
      })
      if (res) {
        return res.attributes['user-type-name']
      } else {
        return '役職を選択'
      }
    },
    isUserType () {
      return this.userTypeId
    },
    shops () {
      let results = [{ id: null, type: 'shop-types', attributes: { 'shop-name': '店舗を選択' }}]
      return results.concat(this.$store.getters.shopsAll.filter(shop => {
         // 表示しない店舗を取り除く
        if (![4, 730, 750, 800].includes(Number(shop.id))) {
          return shop
        }
      }))
    },
    shopName () {
      let res = this.$store.getters.shopsAll.find(item => {
        return item.id === this.shopId
      })
      if (res) {
        return res.attributes['shop-name']
      } else {
        return '店舗を選択'
      }
    },
    isShop () {
      return this.shopId
    },
    isUserName () {
      return this.userName.length > 0
    }
  },
  methods: {
    goEsMycardDetail: function (id) {
      window.sessionStorage.setItem('es_mycard_detail_referrer', this.$router.history.current.path)
      this.$router.push({ path: `/es_mycard/${id}/detail`})
    },
    async getShopName () {
      let data = {
        shop_id: localStorage.shop_id
      }
      let res = await this.$store.dispatch('GET_SHOP_NAME', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.displayShopName = res.shop_name.shop_name
    },
    async getUserTypes () {
      await this.$store.dispatch('USERTYPE_ALL_GET', {})
        .catch(err => {
          console.log(err)
          return
        })
    },
    async getShops () {
      await this.$store.dispatch('SHOP_ALL_GET', {})
      .catch(err => {
        console.log(err)
        return
      })
    },
    goEsMycardLikeList: function (cardId) {
      window.sessionStorage.setItem('es_mycard_like_list_referrer', this.$router.history.current.path)
      this.$router.push({ path: `/like_list/${cardId}` })
    },
    async search (readMore) {
      let data = {}
      if (this.selectedTab === 'new') {
        if (this.sortStart.year && this.sortStart.month && this.sortStart.day) {
          data['start_date'] = this.sortStart.year + '-' + ('00' + this.sortStart.month).slice(-2) + '-' + ('00' + this.sortStart.day).slice(-2)
        }
        if (this.sortEnd.year && this.sortEnd.month && this.sortEnd.day) {
          data['end_date'] = this.sortEnd.year + '-' + ('00' + this.sortEnd.month).slice(-2) + '-' + ('00' + this.sortEnd.day).slice(-2)
        }
        if (this.userTypeId) {
          data['user_type_id'] = this.userTypeId
        }
        if (this.selectedShop === 'all' && this.shopId) {
          data['search_shop'] = this.shopId
        }
        if (this.userName) {
          data['user_name'] = this.userName
        }
      }
      if (this.selectedShop === 'my') {
        data['search_shop'] = localStorage.shop_id
      }
      if (this.selectedTab === 'new') {
        data['order_key'] = 'created_at desc'
      } else {
        data['order_key'] = 'like'
      }

      let isBackPageSearch = false
      let isReadMore = false
      let isFirstLoad = false
      console.log(`readMore=${readMore}`)
      if (readMore == 'addLoad') {
        this.currentPage += 1
        data['current_page'] = this.currentPage
        data['add_search'] = true
        isReadMore = true
      } else {
        if (readMore == 'firstLoad') {
          this.currentPage = 0
          isFirstLoad = true
        } else {
          this.currentPage += 1
          data['current_page'] = this.currentPage
          data['back_page_search'] = true
          isBackPageSearch = true
        }
        this.searchEnd = false
      }

      let res = await this.$store.dispatch('GET_MYCARD_LIST', { data: data, isReadMore: isReadMore, isBackPageSearch: isBackPageSearch, isFirstLoad: isFirstLoad })
      .catch(err => {
        console.log(err)
        return
      })
      if (readMore == 'addLoad') {
        this.cardList = res.cards
      } else {
        this.cardList = res.cards
        this.displayToday = res.today
        this.displayLastMounthDate = res.last_month_date
        this.searchEnd = true
      }
      this.nextExist = res.next_exist
      this.createshowHamburgerList()
    },
    createshowHamburgerList () {
      this.cardList.forEach(_ => {
        this.showHamburgerList.push(false)
      })
    },
    setSelectedDate (searchType = 'firstLoad') {
      this.sortStartsToString = ''
      this.sortEndsToString = ''
      this.shopNameToString = ''
      this.userTypeToString = ''
      this.userNameToString = ''
      if (this.isSettedSortStarts) {
        this.sortStartsToString += `${this.sortStart.year}年${this.sortStart.month}月${this.sortStart.day}日`
      }
      if (this.isSettedSortEnds) {
        this.sortEndsToString += `${this.sortEnd.year}年${this.sortEnd.month}月${this.sortEnd.day}日`
      }
      if (this.isShop) {
        this.shopNameToString = this.shopName
      }
      if (this.isUserType) {
        this.userTypeToString = this.userTypeName
      }
      if (this.isUserName) {
        this.userNameToString = this.userName
      }
      this.toggleAccordion()
      this.search(searchType)
    },
    async sendLike (index, cardId) {
      if (!this.isLikePushing) {
        this.isLikePushing = true
        const currentData = this.cardList[index]
        currentData.you_liked = !currentData.you_liked
        let data = {
          card_id: cardId
        }
        let res = await this.$store.dispatch('CARD_LIKE_UPDATE', { data: data })
        .catch(err => {
          console.log(err)
          return
        })
        if (res.success === 'delete') {
          currentData.like -= 1
        } else {
          currentData.like += 1
        }
        this.cardList.splice(index, 1, currentData)
        this.isLikePushing = false
      }
    },
    async sendFavorite (index, cardId) {
      const currentData = this.cardList[index]
      currentData.you_favorited = !currentData.you_favorited
      this.cardList.splice(index, 1, currentData)
      let data = {
        card_id: cardId
      }
      await this.$store.dispatch('CARD_FAVORITE_UPDATE', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
    },
    showDeleteCardModal (id, cardIndex) {
      this.deleteTarget = id
      this.deleteTargetIndex = cardIndex
      this.toggleHamburger(cardIndex)
    },
    async deleteCardByTargetId () {
      let data = {
        card_id: this.deleteTarget
      }
      await this.$store.dispatch('CARD_DELETE', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.cardList.splice(this.deleteTargetIndex, 1)
      this.showHamburgerList.splice(this.deleteTargetIndex, 1)
      this.deleteTarget = null
      this.showDeleteCardCompleteModal = true
    },
    // animations
    toggleAccordion () {
      this.accordion = !this.accordion
    },
    toggleHamburger (index) {
      // ハンバーガーメニュー初期化
      for (let listIndex = 0; listIndex < this.showHamburgerList.length; listIndex++) {
        if (index !== listIndex) {
          this.showHamburgerList[listIndex] = false
        }
      }
      const currentState = this.showHamburgerList[index]
      this.showHamburgerList.splice(index, 1, !currentState)
    },
    accordionBeforeEnter (el) {
      el.style.height = '0'
    },
    accordionEnter (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    accordionBeforeLeave (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    accordionLeave (el) {
      el.style.height = '0'
    },
    getDayCount: function () {
      this.dayCount = new Date(
        this.sortStart.year,
        this.sortStart.month,
        0
      ).getDate()
    },
    getEndDayCount: function () {
      this.endDayCount = new Date(
        this.sortEnd.year,
        this.sortEnd.month,
        0
      ).getDate()
    },
    authorityCheck: function (shopId) {
      if (localStorage.user_authority == 1) {
        return true
      }
      if (localStorage.user_authority <= 2 && shopId == localStorage.shop_id) {
        return true
      }
      return false
    },
    handleScroll () {
      if (this.isScrollDoneFlag) {
        window.sessionStorage.removeItem('mycard_list_scroll_top')
        this.isScrollDoneFlag = false
      }
    },
    rmEmoji: function (text) {
      this.cardList[this.reportTargetIndex].problem_report_reason = utils.removeEmoji(text)
    },
    cancelReportProblem: function () {
      // 問題報告キャンセル処理
      this.isReportProblemModal = false
      this.cardList[this.reportTargetIndex].problem_report_reason = ''
    },
    showReportProblem (cardIndex) {
      // 問題報告モーダル表示
      this.isReportProblemModal = true
      this.toggleHamburger(cardIndex)
      this.reportTargetIndex = cardIndex
    },
    async reportProblem () {
      // ボタン連打時に複数報告されないように制御
      if (this.isProblemReported) return
      this.isProblemReported = true
      // 問題報告処理
      const data = {
        id: this.cardList[this.reportTargetIndex].id,
        problem_report_user_id: localStorage.user_id,
        problem_report_reason: this.cardList[this.reportTargetIndex].problem_report_reason,
        url: process.env.ASOVI_URL + `/#/es_mycard/${this.cardList[this.reportTargetIndex].id}/detail`
      }
      await this.$store.dispatch('PROBLEM_REPORT_UPDATE', data)
      .catch(err => {
        console.error(err)
        return
      })
      this.isReportProblemModal = false
      this.cardList[this.reportTargetIndex].is_problem_reported = 1
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/es-mycard-list.js